import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

export enum DateFormatEnum {
  SHORTTIME = 'shortTime',
  MICRO = 'micro',
  MINI = 'mini',
  SHORT = 'short',
  MEDIUM = 'medium',
  LONG = 'long',
  FULL = 'full',
  MEDIUMDATE = 'mediumDate',
  LONGDATE = 'longDate',
  LONGDATE2 = 'longDate2',
  LONGDATE_TIME = 'longDateTime',
  FULLDATE = 'fullDate',
  FULLDATETIME = 'fullDateTime',
  SHORTDATE = 'shortDate',
  SHORTYEAR = 'shortYear',
  LONGDATE_WITH_TZ = 'longDateTimeTz',
}

@Pipe({
  name: 'dateUserLocale',
})
export class DateUserLocalePipe implements PipeTransform {
  transform(date: any, format?: string | DateFormatEnum, targetTimezone?: string): string {
    // Create moment object with optional timezone
    const momentDate = targetTimezone ? moment.tz(date, targetTimezone) : moment(date);
    switch (format) {
      case DateFormatEnum.SHORTTIME:
        return momentDate.format('LT');
      case DateFormatEnum.MICRO:
        return momentDate.format('DD');
      case DateFormatEnum.MINI:
        return momentDate.format('MMMM D');
      case DateFormatEnum.SHORT:
        return momentDate.format('DD MM YYYY, h:mm a');
      case DateFormatEnum.MEDIUM:
        return momentDate.format('lll');
      case DateFormatEnum.LONG:
        return momentDate.format('LLL');
      case DateFormatEnum.FULL:
        return momentDate.format('LLLL');
      case DateFormatEnum.LONGDATE_WITH_TZ:
        return momentDate.format('MMM Do YYYY, h:mm a (zz)');
      case DateFormatEnum.MEDIUMDATE:
        return momentDate.format('ll');
      case DateFormatEnum.LONGDATE:
        return momentDate.format('LL');
      case DateFormatEnum.LONGDATE2:
        return momentDate.format('MMM Do, YYYY');
      case DateFormatEnum.LONGDATE_TIME:
        return momentDate.format('MMM Do YYYY, h:mm a');
      case DateFormatEnum.SHORTYEAR:
        return momentDate.format('MMM. d, y');
      case DateFormatEnum.FULLDATE:
        return momentDate.format('dddd, MMM DD, YYYY');
      case DateFormatEnum.FULLDATETIME:
        return momentDate.format('dddd, MMM DD YYYY, h:mm A');
      case DateFormatEnum.SHORTDATE:
      default:
        return momentDate.format('LL');
    }
  }
}
